const api = `${document.env.API_HOST}/v1`;
const apiB2B = document.env.B2B_HOST;

async function handleErrors(res) {
  const { ok, status } = res;
  if (!ok) {
    if (status === 500) {
      localStorage.clear();
      location.href = '/login';
      throw Error('Token Inválido');
    }
    let json = await res.json();
    let message = !!json && !!json.message ? json.message : res.statusText;
    throw Error(message);
  }
  return res;
}

function request(method, url, body, opts = {}) {
  const config = {
    method,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  };
  if (opts.isFile) {
    config.body = body;
  } else {
    config.headers['Content-Type'] = 'application/json';
    config.body = JSON.stringify(body);
  }
  return fetch(url, config)
    .then(handleErrors)
    .then((res) => res.json());
}

const get = (url) => request('GET', `${api}${url}`);
const post = (url, body, opts = {}) =>
  request('POST', `${api}${url}`, body, opts);
const put = (url, body, opts = {}) =>
  request('PUT', `${api}${url}`, body, opts);
const del = (url, body) => request('DELETE', `${api}${url}`, body);
const getLogo = () => request('GET', `${apiB2B}/logo`);
const setLogo = (logo) => request('POST', `${apiB2B}/logo`, { logo });

function getToken(body) {
  const config = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  };
  return fetch(`${api}/login`, config)
    .then(handleErrors)
    .then((res) => res.json());
}

function uploadImage({ el, str, dim }) {
  let { 0: w, 1: h } = dim.split('x');
  let formData = new FormData();
  formData.append('w', w);
  formData.append('h', h);
  formData.append('img', el.files[0], el.files[0].name);
  return post(`/upload${str}`, formData, { isFile: true });
}

export { api, get, post, put, del, getLogo, setLogo, getToken, uploadImage };



// WEBPACK FOOTER //
// ./src/helpers/apiRequest.js